export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR',
    CLEAR_ALL: 'ALERT_CLEAR_ALL',
    CLEAR_OTHER_PAGES: 'ALERT_CLEAR_OTHER_PAGES',
};
